/**
 * @file reducers/Trending/reducer.js
 */
import { createSlice } from "@reduxjs/toolkit";

export const initialTrendingState = () => {
    return {
        sections: {},
        list: [],
    };
};

const trendingSlice = createSlice({
    name: "trending",
    initialState: initialTrendingState(),
    reducers: {
        receive_trending: (state, action) => {
            return {
                ...state,
                list: action.payload.contentList,
                sections: {
                    ...state.sections,
                    [action.payload.section]: action.payload.contentList,
                },
            };
        },

        reset_trending: (state) => {
            return {
                ...state,
                list: [],
            };
        },
    },
});

export const { receive_trending, reset_trending } = trendingSlice.actions;

export default trendingSlice.reducer;
